import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { ISesionType } from "../../interfaces/tipo-capacitacion";

const endPoint = `${environment.apiUrlCap}/api/catalogs`;
@Injectable({
  providedIn: "root",
})
export class TipoSesionService {
  constructor(private http: HttpClient) {}

  getTipoSesion(): Observable<ISesionType[]> {
    return this.http
      .get<ResponseDataInterfaces<ISesionType[]>>(
        `${endPoint}/calendar/tipoSesion`
      )
      .pipe(map((response: any) => response.data));
  }
}
